/**
    A Simple key value based database
**/
define('modules/database',["jquery", "dexie"], function($, Dexie) {
    var database = new Dexie("productFinder");
    var defaultTables = {
        params : 'name'
    };

    function Database(tables) {
        database.version(1).stores($.extend(true, {}, defaultTables, tables || {}));
        Database = null;

        return {
            get  : function(key, callback) {
                callback = callback || $.noop;

                var inputType = 'array';
                if(typeof key == 'string') {
                    key = [key];
                    inputType = 'string';
                }

                var startsWithKeys = [];
                var exactMatchKeys = [];
                key.forEach(function(k) {
                    if(/\*$/.test(k)) {
                        startsWithKeys.push(k.replace(/\*$/, ''));
                    } else {
                        exactMatchKeys.push(k);
                    }
                });

                return database.params
                        .where("name").startsWithAnyOf(startsWithKeys)
                        .or("name").anyOf(exactMatchKeys)
                        .toArray(function(data) {
                            var output = {};

                            data.forEach(function(r) {
                                try {
                                    output[r.name] = JSON.parse(r.value);
                                } catch(e) {
                                    output[r.name] = r.value;
                                }
                            });

                            exactMatchKeys.forEach(function(k) {
                                if(!output.hasOwnProperty(k)) {
                                    output[k] = null;
                                }
                            });

                            if(inputType == 'string') {
                                output = output[Object.keys(output)[0]];
                            }

                            callback(output);
                        });
            },
            set : function(key, value) {
                var that = this;
                var cache = {}, promise;

                if(typeof key == 'object') {
                    cache = $.extend(true, {}, key);

                    var values = [];
                    $.each(key, function(k, v) {
                        if(typeof v == 'object') {
                            v = JSON.stringify(v);
                        }
                        values.push({name : k, value : v});
                    });
                    promise = database.params.bulkPut(values);
                } else {
                    cache[key] = value;

                    if(typeof value == 'object') {
                        value = JSON.stringify(value);
                    }
                    promise = database.params.put({name : key, value : value});
                }

                return {
                    cache : cache,
                    promise : promise
                };
            },
            instance : database
        };
    };

    return Database;
});
